import { ReactNode } from 'react';
import styled from 'styled-components';
import Button from '@hotmart/space-lib/dist/components/button';

const PillContainer = styled.div`
  button {
    height: 24px;
  }
`;

export type PillButtonProps = {
  children: ReactNode;
  ariaLabel: string;
  active?: boolean;
  className?: string;
  testId?: string;
  disabled?: boolean;
  handleClick?: () => void;
};

const PillButton = ({
  ariaLabel,
  handleClick,
  children,
  className,
  testId,
  active,
  disabled
}: PillButtonProps) => {
  return (
    <PillContainer>
      <Button
        variation="default"
        aria-label={ariaLabel}
        onClick={handleClick}
        active={active}
        className={`${className} _rounded-pill _text-1 _mr-2 _text-gray-500 _d-flex _align-items-center _px-2`}
        data-test={testId}
        disabled={disabled}
      >
        {children}
      </Button>
    </PillContainer>
  );
};

export default PillButton;
